import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  const isFor = ['Personas que acaban de terminar una relación y no saben cómo seguir adelante.', "Quienes están atrapados en un ciclo de 'ruptura y regreso' tóxico.", 'Alguien que siente que su felicidad depende totalmente de la atención de otra persona.', 'Hombres y mujeres que sufren de insomnio y rumiación obsesiva por un ex.'];
  const notFor = ['Personas que buscan una fórmula mágica para que su ex regrese.', 'Quienes no están dispuestos a aplicar contacto cero radical por 21 días.'];
  return <section className="py-16 md:py-24 px-4 bg-brand-slate/30" data-id="element-217">
      <div className="max-w-4xl mx-auto" data-id="element-218">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-219">
          <FadeIn data-id="element-220">
            <div className="p-8 rounded-2xl bg-brand-dark border border-white/5 h-full" data-id="element-221">
              <h3 className="font-serif text-2xl text-white mb-8 flex items-center gap-3" data-id="element-222">
                <span className="bg-green-500/10 p-2 rounded-full text-green-500" data-id="element-223">
                  <Check className="w-5 h-5" data-id="element-224" />
                </span>
                Para quién es esto
              </h3>
              <ul className="space-y-5" data-id="element-225">
                {isFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-226">
                    <Check className="w-5 h-5 text-green-500/70 flex-shrink-0 mt-0.5" data-id="element-227" />
                    <span className="leading-relaxed" data-id="element-228">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-229">
            <div className="p-8 rounded-2xl bg-brand-dark border border-white/5 h-full" data-id="element-230">
              <h3 className="font-serif text-2xl text-white mb-8 flex items-center gap-3" data-id="element-231">
                <span className="bg-brand-danger/10 p-2 rounded-full text-brand-danger" data-id="element-232">
                  <X className="w-5 h-5" data-id="element-233" />
                </span>
                Para quién NO es
              </h3>
              <ul className="space-y-5" data-id="element-234">
                {notFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-235">
                    <X className="w-5 h-5 text-brand-danger/70 flex-shrink-0 mt-0.5" data-id="element-236" />
                    <span className="leading-relaxed" data-id="element-237">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}